"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/leads/v1/input.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputFiles = exports.InputFile = exports.InputValue = exports.InputValidation_ContentTypeEntry = exports.InputValidation_Length = exports.InputValidation = exports.DefaultValue = exports.InputDescriptor = exports.inputNameToJSON = exports.inputNameFromJSON = exports.InputName = exports.inputTypeToJSON = exports.inputTypeFromJSON = exports.InputType = void 0;
/* eslint-disable */
exports.InputType = {
    INPUT_TYPE_UNSPECIFIED: "INPUT_TYPE_UNSPECIFIED",
    INPUT_TYPE_INT32: "INPUT_TYPE_INT32",
    INPUT_TYPE_STRING: "INPUT_TYPE_STRING",
    INPUT_TYPE_BOOL: "INPUT_TYPE_BOOL",
    INPUT_TYPE_FILES: "INPUT_TYPE_FILES",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function inputTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "INPUT_TYPE_UNSPECIFIED":
            return exports.InputType.INPUT_TYPE_UNSPECIFIED;
        case 1:
        case "INPUT_TYPE_INT32":
            return exports.InputType.INPUT_TYPE_INT32;
        case 2:
        case "INPUT_TYPE_STRING":
            return exports.InputType.INPUT_TYPE_STRING;
        case 3:
        case "INPUT_TYPE_BOOL":
            return exports.InputType.INPUT_TYPE_BOOL;
        case 4:
        case "INPUT_TYPE_FILES":
            return exports.InputType.INPUT_TYPE_FILES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.InputType.UNRECOGNIZED;
    }
}
exports.inputTypeFromJSON = inputTypeFromJSON;
function inputTypeToJSON(object) {
    switch (object) {
        case exports.InputType.INPUT_TYPE_UNSPECIFIED:
            return "INPUT_TYPE_UNSPECIFIED";
        case exports.InputType.INPUT_TYPE_INT32:
            return "INPUT_TYPE_INT32";
        case exports.InputType.INPUT_TYPE_STRING:
            return "INPUT_TYPE_STRING";
        case exports.InputType.INPUT_TYPE_BOOL:
            return "INPUT_TYPE_BOOL";
        case exports.InputType.INPUT_TYPE_FILES:
            return "INPUT_TYPE_FILES";
        case exports.InputType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.inputTypeToJSON = inputTypeToJSON;
/**
 * InputName represent the name of a input, it allow use to determine the i18n for the label, helper text...
 * The type of the in
 */
exports.InputName = {
    INPUT_NAME_UNSPECIFIED: "INPUT_NAME_UNSPECIFIED",
    INPUT_NAME_FINANCIAL_NEED_ESTIMATE: "INPUT_NAME_FINANCIAL_NEED_ESTIMATE",
    INPUT_NAME_LEGAL_FORM: "INPUT_NAME_LEGAL_FORM",
    INPUT_NAME_EMAIL: "INPUT_NAME_EMAIL",
    INPUT_NAME_SECTOR: "INPUT_NAME_SECTOR",
    INPUT_NAME_FIRSTNAME: "INPUT_NAME_FIRSTNAME",
    INPUT_NAME_LASTNAME: "INPUT_NAME_LASTNAME",
    INPUT_NAME_PHONE: "INPUT_NAME_PHONE",
    INPUT_NAME_PROJECT_DESCRIPTION: "INPUT_NAME_PROJECT_DESCRIPTION",
    INPUT_NAME_REGION: "INPUT_NAME_REGION",
    INPUT_NAME_FUNNEL_TYPE: "INPUT_NAME_FUNNEL_TYPE",
    INPUT_NAME_COMMERCIAL_NAME: "INPUT_NAME_COMMERCIAL_NAME",
    INPUT_NAME_WEBSITE_URL: "INPUT_NAME_WEBSITE_URL",
    INPUT_NAME_FACEBOOK_URL: "INPUT_NAME_FACEBOOK_URL",
    INPUT_NAME_INSTAGRAM_URL: "INPUT_NAME_INSTAGRAM_URL",
    INPUT_NAME_DONATION_FINANCIAL_NEED: "INPUT_NAME_DONATION_FINANCIAL_NEED",
    /** INPUT_NAME_FIRST_CIRCLE_ESTIMATE - estimate community ready to support the person */
    INPUT_NAME_FIRST_CIRCLE_ESTIMATE: "INPUT_NAME_FIRST_CIRCLE_ESTIMATE",
    INPUT_NAME_DEVELOPMENT_STAGE: "INPUT_NAME_DEVELOPMENT_STAGE",
    INPUT_NAME_FUND_ALLOCATION: "INPUT_NAME_FUND_ALLOCATION",
    INPUT_NAME_GLOBAL_FINANCIAL_NEED: "INPUT_NAME_GLOBAL_FINANCIAL_NEED",
    INPUT_NAME_PERSONAL_FUNDS: "INPUT_NAME_PERSONAL_FUNDS",
    INPUT_NAME_ADDITIONAL_FUNDS: "INPUT_NAME_ADDITIONAL_FUNDS",
    INPUT_NAME_BANKING_LOAN: "INPUT_NAME_BANKING_LOAN",
    INPUT_NAME_SIREN: "INPUT_NAME_SIREN",
    /** INPUT_NAME_BCE - belgian equivalent to france SIREN */
    INPUT_NAME_BCE: "INPUT_NAME_BCE",
    INPUT_NAME_ACHIEVED_TURNOVER: "INPUT_NAME_ACHIEVED_TURNOVER",
    INPUT_NAME_PROJECTED_TURNOVER: "INPUT_NAME_PROJECTED_TURNOVER",
    /** INPUT_NAME_BANK_STATEMENTS_ATTACHMENTS - That is "relevé bancaire" in french */
    INPUT_NAME_BANK_STATEMENTS_ATTACHMENTS: "INPUT_NAME_BANK_STATEMENTS_ATTACHMENTS",
    /** INPUT_NAME_BALANCE_SHEET_ATTACHMENTS - That is "Liasses fiscales" in french */
    INPUT_NAME_BALANCE_SHEET_ATTACHMENTS: "INPUT_NAME_BALANCE_SHEET_ATTACHMENTS",
    /** INPUT_NAME_INVESTOR_TYPE - psfp qualification: */
    INPUT_NAME_INVESTOR_TYPE: "INPUT_NAME_INVESTOR_TYPE",
    INPUT_NAME_NATURAL_INCOME_THRESHOLD: "INPUT_NAME_NATURAL_INCOME_THRESHOLD",
    INPUT_NAME_NATURAL_FINANCIAL_ASSETS_THRESHOLD: "INPUT_NAME_NATURAL_FINANCIAL_ASSETS_THRESHOLD",
    INPUT_NAME_NATURAL_TRANSACTIONS_FREQUENCY_THRESHOLD: "INPUT_NAME_NATURAL_TRANSACTIONS_FREQUENCY_THRESHOLD",
    INPUT_NAME_NATURAL_FINANCIAL_JOB: "INPUT_NAME_NATURAL_FINANCIAL_JOB",
    INPUT_NAME_NATURAL_EXECUTIVE_JOB: "INPUT_NAME_NATURAL_EXECUTIVE_JOB",
    INPUT_NAME_LEGAL_THRESHOLDS: "INPUT_NAME_LEGAL_THRESHOLDS",
    INPUT_NAME_SECTORS_OF_INTEREST: "INPUT_NAME_SECTORS_OF_INTEREST",
    INPUT_NAME_INVESTMENT_HORIZON: "INPUT_NAME_INVESTMENT_HORIZON",
    INPUT_NAME_RISK_APPETITE: "INPUT_NAME_RISK_APPETITE",
    INPUT_NAME_STRESS_FOR_CASH: "INPUT_NAME_STRESS_FOR_CASH",
    INPUT_NAME_CROWDFUNDING_EXPERIENCE: "INPUT_NAME_CROWDFUNDING_EXPERIENCE",
    INPUT_NAME_LAST_YEAR_INVESTED_AMOUNT: "INPUT_NAME_LAST_YEAR_INVESTED_AMOUNT",
    INPUT_NAME_OTHER_INVESTMENT_EXPERIENCE: "INPUT_NAME_OTHER_INVESTMENT_EXPERIENCE",
    INPUT_NAME_NOT_SAVING_ACCOUNT_ACKNOWLEDGMENT: "INPUT_NAME_NOT_SAVING_ACCOUNT_ACKNOWLEDGMENT",
    INPUT_NAME_DEFAULT_RISK_ACKNOWLEDGMENT: "INPUT_NAME_DEFAULT_RISK_ACKNOWLEDGMENT",
    INPUT_NAME_LIQUIDITY_RISK_ACKNOWLEDGMENT: "INPUT_NAME_LIQUIDITY_RISK_ACKNOWLEDGMENT",
    INPUT_NAME_MAX_RATIO_ACKNOWLEDGMENT: "INPUT_NAME_MAX_RATIO_ACKNOWLEDGMENT",
    INPUT_NAME_YEARLY_NET_INCOME: "INPUT_NAME_YEARLY_NET_INCOME",
    INPUT_NAME_TOTAL_LIQUID_ASSET: "INPUT_NAME_TOTAL_LIQUID_ASSET",
    INPUT_NAME_YEARLY_FINANCIAL_COMMITMENT: "INPUT_NAME_YEARLY_FINANCIAL_COMMITMENT",
    /** INPUT_NAME_TEST_ATTACHMENT - tests */
    INPUT_NAME_TEST_ATTACHMENT: "INPUT_NAME_TEST_ATTACHMENT",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function inputNameFromJSON(object) {
    switch (object) {
        case 0:
        case "INPUT_NAME_UNSPECIFIED":
            return exports.InputName.INPUT_NAME_UNSPECIFIED;
        case 1:
        case "INPUT_NAME_FINANCIAL_NEED_ESTIMATE":
            return exports.InputName.INPUT_NAME_FINANCIAL_NEED_ESTIMATE;
        case 2:
        case "INPUT_NAME_LEGAL_FORM":
            return exports.InputName.INPUT_NAME_LEGAL_FORM;
        case 3:
        case "INPUT_NAME_EMAIL":
            return exports.InputName.INPUT_NAME_EMAIL;
        case 4:
        case "INPUT_NAME_SECTOR":
            return exports.InputName.INPUT_NAME_SECTOR;
        case 5:
        case "INPUT_NAME_FIRSTNAME":
            return exports.InputName.INPUT_NAME_FIRSTNAME;
        case 6:
        case "INPUT_NAME_LASTNAME":
            return exports.InputName.INPUT_NAME_LASTNAME;
        case 7:
        case "INPUT_NAME_PHONE":
            return exports.InputName.INPUT_NAME_PHONE;
        case 9:
        case "INPUT_NAME_PROJECT_DESCRIPTION":
            return exports.InputName.INPUT_NAME_PROJECT_DESCRIPTION;
        case 10:
        case "INPUT_NAME_REGION":
            return exports.InputName.INPUT_NAME_REGION;
        case 11:
        case "INPUT_NAME_FUNNEL_TYPE":
            return exports.InputName.INPUT_NAME_FUNNEL_TYPE;
        case 100:
        case "INPUT_NAME_COMMERCIAL_NAME":
            return exports.InputName.INPUT_NAME_COMMERCIAL_NAME;
        case 101:
        case "INPUT_NAME_WEBSITE_URL":
            return exports.InputName.INPUT_NAME_WEBSITE_URL;
        case 102:
        case "INPUT_NAME_FACEBOOK_URL":
            return exports.InputName.INPUT_NAME_FACEBOOK_URL;
        case 103:
        case "INPUT_NAME_INSTAGRAM_URL":
            return exports.InputName.INPUT_NAME_INSTAGRAM_URL;
        case 104:
        case "INPUT_NAME_DONATION_FINANCIAL_NEED":
            return exports.InputName.INPUT_NAME_DONATION_FINANCIAL_NEED;
        case 105:
        case "INPUT_NAME_FIRST_CIRCLE_ESTIMATE":
            return exports.InputName.INPUT_NAME_FIRST_CIRCLE_ESTIMATE;
        case 200:
        case "INPUT_NAME_DEVELOPMENT_STAGE":
            return exports.InputName.INPUT_NAME_DEVELOPMENT_STAGE;
        case 201:
        case "INPUT_NAME_FUND_ALLOCATION":
            return exports.InputName.INPUT_NAME_FUND_ALLOCATION;
        case 202:
        case "INPUT_NAME_GLOBAL_FINANCIAL_NEED":
            return exports.InputName.INPUT_NAME_GLOBAL_FINANCIAL_NEED;
        case 203:
        case "INPUT_NAME_PERSONAL_FUNDS":
            return exports.InputName.INPUT_NAME_PERSONAL_FUNDS;
        case 204:
        case "INPUT_NAME_ADDITIONAL_FUNDS":
            return exports.InputName.INPUT_NAME_ADDITIONAL_FUNDS;
        case 205:
        case "INPUT_NAME_BANKING_LOAN":
            return exports.InputName.INPUT_NAME_BANKING_LOAN;
        case 206:
        case "INPUT_NAME_SIREN":
            return exports.InputName.INPUT_NAME_SIREN;
        case 207:
        case "INPUT_NAME_BCE":
            return exports.InputName.INPUT_NAME_BCE;
        case 208:
        case "INPUT_NAME_ACHIEVED_TURNOVER":
            return exports.InputName.INPUT_NAME_ACHIEVED_TURNOVER;
        case 209:
        case "INPUT_NAME_PROJECTED_TURNOVER":
            return exports.InputName.INPUT_NAME_PROJECTED_TURNOVER;
        case 210:
        case "INPUT_NAME_BANK_STATEMENTS_ATTACHMENTS":
            return exports.InputName.INPUT_NAME_BANK_STATEMENTS_ATTACHMENTS;
        case 211:
        case "INPUT_NAME_BALANCE_SHEET_ATTACHMENTS":
            return exports.InputName.INPUT_NAME_BALANCE_SHEET_ATTACHMENTS;
        case 300:
        case "INPUT_NAME_INVESTOR_TYPE":
            return exports.InputName.INPUT_NAME_INVESTOR_TYPE;
        case 301:
        case "INPUT_NAME_NATURAL_INCOME_THRESHOLD":
            return exports.InputName.INPUT_NAME_NATURAL_INCOME_THRESHOLD;
        case 302:
        case "INPUT_NAME_NATURAL_FINANCIAL_ASSETS_THRESHOLD":
            return exports.InputName.INPUT_NAME_NATURAL_FINANCIAL_ASSETS_THRESHOLD;
        case 303:
        case "INPUT_NAME_NATURAL_TRANSACTIONS_FREQUENCY_THRESHOLD":
            return exports.InputName.INPUT_NAME_NATURAL_TRANSACTIONS_FREQUENCY_THRESHOLD;
        case 304:
        case "INPUT_NAME_NATURAL_FINANCIAL_JOB":
            return exports.InputName.INPUT_NAME_NATURAL_FINANCIAL_JOB;
        case 305:
        case "INPUT_NAME_NATURAL_EXECUTIVE_JOB":
            return exports.InputName.INPUT_NAME_NATURAL_EXECUTIVE_JOB;
        case 310:
        case "INPUT_NAME_LEGAL_THRESHOLDS":
            return exports.InputName.INPUT_NAME_LEGAL_THRESHOLDS;
        case 320:
        case "INPUT_NAME_SECTORS_OF_INTEREST":
            return exports.InputName.INPUT_NAME_SECTORS_OF_INTEREST;
        case 321:
        case "INPUT_NAME_INVESTMENT_HORIZON":
            return exports.InputName.INPUT_NAME_INVESTMENT_HORIZON;
        case 322:
        case "INPUT_NAME_RISK_APPETITE":
            return exports.InputName.INPUT_NAME_RISK_APPETITE;
        case 323:
        case "INPUT_NAME_STRESS_FOR_CASH":
            return exports.InputName.INPUT_NAME_STRESS_FOR_CASH;
        case 324:
        case "INPUT_NAME_CROWDFUNDING_EXPERIENCE":
            return exports.InputName.INPUT_NAME_CROWDFUNDING_EXPERIENCE;
        case 325:
        case "INPUT_NAME_LAST_YEAR_INVESTED_AMOUNT":
            return exports.InputName.INPUT_NAME_LAST_YEAR_INVESTED_AMOUNT;
        case 326:
        case "INPUT_NAME_OTHER_INVESTMENT_EXPERIENCE":
            return exports.InputName.INPUT_NAME_OTHER_INVESTMENT_EXPERIENCE;
        case 327:
        case "INPUT_NAME_NOT_SAVING_ACCOUNT_ACKNOWLEDGMENT":
            return exports.InputName.INPUT_NAME_NOT_SAVING_ACCOUNT_ACKNOWLEDGMENT;
        case 328:
        case "INPUT_NAME_DEFAULT_RISK_ACKNOWLEDGMENT":
            return exports.InputName.INPUT_NAME_DEFAULT_RISK_ACKNOWLEDGMENT;
        case 329:
        case "INPUT_NAME_LIQUIDITY_RISK_ACKNOWLEDGMENT":
            return exports.InputName.INPUT_NAME_LIQUIDITY_RISK_ACKNOWLEDGMENT;
        case 330:
        case "INPUT_NAME_MAX_RATIO_ACKNOWLEDGMENT":
            return exports.InputName.INPUT_NAME_MAX_RATIO_ACKNOWLEDGMENT;
        case 331:
        case "INPUT_NAME_YEARLY_NET_INCOME":
            return exports.InputName.INPUT_NAME_YEARLY_NET_INCOME;
        case 332:
        case "INPUT_NAME_TOTAL_LIQUID_ASSET":
            return exports.InputName.INPUT_NAME_TOTAL_LIQUID_ASSET;
        case 333:
        case "INPUT_NAME_YEARLY_FINANCIAL_COMMITMENT":
            return exports.InputName.INPUT_NAME_YEARLY_FINANCIAL_COMMITMENT;
        case 1000:
        case "INPUT_NAME_TEST_ATTACHMENT":
            return exports.InputName.INPUT_NAME_TEST_ATTACHMENT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.InputName.UNRECOGNIZED;
    }
}
exports.inputNameFromJSON = inputNameFromJSON;
function inputNameToJSON(object) {
    switch (object) {
        case exports.InputName.INPUT_NAME_UNSPECIFIED:
            return "INPUT_NAME_UNSPECIFIED";
        case exports.InputName.INPUT_NAME_FINANCIAL_NEED_ESTIMATE:
            return "INPUT_NAME_FINANCIAL_NEED_ESTIMATE";
        case exports.InputName.INPUT_NAME_LEGAL_FORM:
            return "INPUT_NAME_LEGAL_FORM";
        case exports.InputName.INPUT_NAME_EMAIL:
            return "INPUT_NAME_EMAIL";
        case exports.InputName.INPUT_NAME_SECTOR:
            return "INPUT_NAME_SECTOR";
        case exports.InputName.INPUT_NAME_FIRSTNAME:
            return "INPUT_NAME_FIRSTNAME";
        case exports.InputName.INPUT_NAME_LASTNAME:
            return "INPUT_NAME_LASTNAME";
        case exports.InputName.INPUT_NAME_PHONE:
            return "INPUT_NAME_PHONE";
        case exports.InputName.INPUT_NAME_PROJECT_DESCRIPTION:
            return "INPUT_NAME_PROJECT_DESCRIPTION";
        case exports.InputName.INPUT_NAME_REGION:
            return "INPUT_NAME_REGION";
        case exports.InputName.INPUT_NAME_FUNNEL_TYPE:
            return "INPUT_NAME_FUNNEL_TYPE";
        case exports.InputName.INPUT_NAME_COMMERCIAL_NAME:
            return "INPUT_NAME_COMMERCIAL_NAME";
        case exports.InputName.INPUT_NAME_WEBSITE_URL:
            return "INPUT_NAME_WEBSITE_URL";
        case exports.InputName.INPUT_NAME_FACEBOOK_URL:
            return "INPUT_NAME_FACEBOOK_URL";
        case exports.InputName.INPUT_NAME_INSTAGRAM_URL:
            return "INPUT_NAME_INSTAGRAM_URL";
        case exports.InputName.INPUT_NAME_DONATION_FINANCIAL_NEED:
            return "INPUT_NAME_DONATION_FINANCIAL_NEED";
        case exports.InputName.INPUT_NAME_FIRST_CIRCLE_ESTIMATE:
            return "INPUT_NAME_FIRST_CIRCLE_ESTIMATE";
        case exports.InputName.INPUT_NAME_DEVELOPMENT_STAGE:
            return "INPUT_NAME_DEVELOPMENT_STAGE";
        case exports.InputName.INPUT_NAME_FUND_ALLOCATION:
            return "INPUT_NAME_FUND_ALLOCATION";
        case exports.InputName.INPUT_NAME_GLOBAL_FINANCIAL_NEED:
            return "INPUT_NAME_GLOBAL_FINANCIAL_NEED";
        case exports.InputName.INPUT_NAME_PERSONAL_FUNDS:
            return "INPUT_NAME_PERSONAL_FUNDS";
        case exports.InputName.INPUT_NAME_ADDITIONAL_FUNDS:
            return "INPUT_NAME_ADDITIONAL_FUNDS";
        case exports.InputName.INPUT_NAME_BANKING_LOAN:
            return "INPUT_NAME_BANKING_LOAN";
        case exports.InputName.INPUT_NAME_SIREN:
            return "INPUT_NAME_SIREN";
        case exports.InputName.INPUT_NAME_BCE:
            return "INPUT_NAME_BCE";
        case exports.InputName.INPUT_NAME_ACHIEVED_TURNOVER:
            return "INPUT_NAME_ACHIEVED_TURNOVER";
        case exports.InputName.INPUT_NAME_PROJECTED_TURNOVER:
            return "INPUT_NAME_PROJECTED_TURNOVER";
        case exports.InputName.INPUT_NAME_BANK_STATEMENTS_ATTACHMENTS:
            return "INPUT_NAME_BANK_STATEMENTS_ATTACHMENTS";
        case exports.InputName.INPUT_NAME_BALANCE_SHEET_ATTACHMENTS:
            return "INPUT_NAME_BALANCE_SHEET_ATTACHMENTS";
        case exports.InputName.INPUT_NAME_INVESTOR_TYPE:
            return "INPUT_NAME_INVESTOR_TYPE";
        case exports.InputName.INPUT_NAME_NATURAL_INCOME_THRESHOLD:
            return "INPUT_NAME_NATURAL_INCOME_THRESHOLD";
        case exports.InputName.INPUT_NAME_NATURAL_FINANCIAL_ASSETS_THRESHOLD:
            return "INPUT_NAME_NATURAL_FINANCIAL_ASSETS_THRESHOLD";
        case exports.InputName.INPUT_NAME_NATURAL_TRANSACTIONS_FREQUENCY_THRESHOLD:
            return "INPUT_NAME_NATURAL_TRANSACTIONS_FREQUENCY_THRESHOLD";
        case exports.InputName.INPUT_NAME_NATURAL_FINANCIAL_JOB:
            return "INPUT_NAME_NATURAL_FINANCIAL_JOB";
        case exports.InputName.INPUT_NAME_NATURAL_EXECUTIVE_JOB:
            return "INPUT_NAME_NATURAL_EXECUTIVE_JOB";
        case exports.InputName.INPUT_NAME_LEGAL_THRESHOLDS:
            return "INPUT_NAME_LEGAL_THRESHOLDS";
        case exports.InputName.INPUT_NAME_SECTORS_OF_INTEREST:
            return "INPUT_NAME_SECTORS_OF_INTEREST";
        case exports.InputName.INPUT_NAME_INVESTMENT_HORIZON:
            return "INPUT_NAME_INVESTMENT_HORIZON";
        case exports.InputName.INPUT_NAME_RISK_APPETITE:
            return "INPUT_NAME_RISK_APPETITE";
        case exports.InputName.INPUT_NAME_STRESS_FOR_CASH:
            return "INPUT_NAME_STRESS_FOR_CASH";
        case exports.InputName.INPUT_NAME_CROWDFUNDING_EXPERIENCE:
            return "INPUT_NAME_CROWDFUNDING_EXPERIENCE";
        case exports.InputName.INPUT_NAME_LAST_YEAR_INVESTED_AMOUNT:
            return "INPUT_NAME_LAST_YEAR_INVESTED_AMOUNT";
        case exports.InputName.INPUT_NAME_OTHER_INVESTMENT_EXPERIENCE:
            return "INPUT_NAME_OTHER_INVESTMENT_EXPERIENCE";
        case exports.InputName.INPUT_NAME_NOT_SAVING_ACCOUNT_ACKNOWLEDGMENT:
            return "INPUT_NAME_NOT_SAVING_ACCOUNT_ACKNOWLEDGMENT";
        case exports.InputName.INPUT_NAME_DEFAULT_RISK_ACKNOWLEDGMENT:
            return "INPUT_NAME_DEFAULT_RISK_ACKNOWLEDGMENT";
        case exports.InputName.INPUT_NAME_LIQUIDITY_RISK_ACKNOWLEDGMENT:
            return "INPUT_NAME_LIQUIDITY_RISK_ACKNOWLEDGMENT";
        case exports.InputName.INPUT_NAME_MAX_RATIO_ACKNOWLEDGMENT:
            return "INPUT_NAME_MAX_RATIO_ACKNOWLEDGMENT";
        case exports.InputName.INPUT_NAME_YEARLY_NET_INCOME:
            return "INPUT_NAME_YEARLY_NET_INCOME";
        case exports.InputName.INPUT_NAME_TOTAL_LIQUID_ASSET:
            return "INPUT_NAME_TOTAL_LIQUID_ASSET";
        case exports.InputName.INPUT_NAME_YEARLY_FINANCIAL_COMMITMENT:
            return "INPUT_NAME_YEARLY_FINANCIAL_COMMITMENT";
        case exports.InputName.INPUT_NAME_TEST_ATTACHMENT:
            return "INPUT_NAME_TEST_ATTACHMENT";
        case exports.InputName.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.inputNameToJSON = inputNameToJSON;
function createBaseInputDescriptor() {
    return {
        name: exports.InputName.INPUT_NAME_UNSPECIFIED,
        type: exports.InputType.INPUT_TYPE_UNSPECIFIED,
        options: [],
        validation: undefined,
        default_value: undefined,
    };
}
exports.InputDescriptor = {
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? inputNameFromJSON(object.name) : exports.InputName.INPUT_NAME_UNSPECIFIED,
            type: isSet(object.type) ? inputTypeFromJSON(object.type) : exports.InputType.INPUT_TYPE_UNSPECIFIED,
            options: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map(function (e) { return globalThis.String(e); }) : [],
            validation: isSet(object.validation) ? exports.InputValidation.fromJSON(object.validation) : undefined,
            default_value: isSet(object.default_value) ? exports.DefaultValue.fromJSON(object.default_value) : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.name !== exports.InputName.INPUT_NAME_UNSPECIFIED) {
            obj.name = inputNameToJSON(message.name);
        }
        if (message.type !== exports.InputType.INPUT_TYPE_UNSPECIFIED) {
            obj.type = inputTypeToJSON(message.type);
        }
        if ((_a = message.options) === null || _a === void 0 ? void 0 : _a.length) {
            obj.options = message.options;
        }
        if (message.validation !== undefined) {
            obj.validation = exports.InputValidation.toJSON(message.validation);
        }
        if (message.default_value !== undefined) {
            obj.default_value = exports.DefaultValue.toJSON(message.default_value);
        }
        return obj;
    },
    create: function (base) {
        return exports.InputDescriptor.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseInputDescriptor();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : exports.InputName.INPUT_NAME_UNSPECIFIED;
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : exports.InputType.INPUT_TYPE_UNSPECIFIED;
        message.options = ((_c = object.options) === null || _c === void 0 ? void 0 : _c.map(function (e) { return e; })) || [];
        message.validation = (object.validation !== undefined && object.validation !== null)
            ? exports.InputValidation.fromPartial(object.validation)
            : undefined;
        message.default_value = (object.default_value !== undefined && object.default_value !== null)
            ? exports.DefaultValue.fromPartial(object.default_value)
            : undefined;
        return message;
    },
};
function createBaseDefaultValue() {
    return { number: undefined, str: undefined, boolean: undefined };
}
exports.DefaultValue = {
    fromJSON: function (object) {
        return {
            number: isSet(object.number) ? globalThis.Number(object.number) : undefined,
            str: isSet(object.str) ? globalThis.String(object.str) : undefined,
            boolean: isSet(object.boolean) ? globalThis.Boolean(object.boolean) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.number !== undefined) {
            obj.number = Math.round(message.number);
        }
        if (message.str !== undefined) {
            obj.str = message.str;
        }
        if (message.boolean !== undefined) {
            obj.boolean = message.boolean;
        }
        return obj;
    },
    create: function (base) {
        return exports.DefaultValue.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseDefaultValue();
        message.number = (_a = object.number) !== null && _a !== void 0 ? _a : undefined;
        message.str = (_b = object.str) !== null && _b !== void 0 ? _b : undefined;
        message.boolean = (_c = object.boolean) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
function createBaseInputValidation() {
    return { required: false, length: undefined, file_size: 0, content_type: {} };
}
exports.InputValidation = {
    fromJSON: function (object) {
        return {
            required: isSet(object.required) ? globalThis.Boolean(object.required) : false,
            length: isSet(object.length) ? exports.InputValidation_Length.fromJSON(object.length) : undefined,
            file_size: isSet(object.file_size) ? globalThis.Number(object.file_size) : 0,
            content_type: isObject(object.content_type)
                ? Object.entries(object.content_type).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Boolean(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.required !== false) {
            obj.required = message.required;
        }
        if (message.length !== undefined) {
            obj.length = exports.InputValidation_Length.toJSON(message.length);
        }
        if (message.file_size !== 0) {
            obj.file_size = Math.round(message.file_size);
        }
        if (message.content_type) {
            var entries = Object.entries(message.content_type);
            if (entries.length > 0) {
                obj.content_type = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.content_type[k] = v;
                });
            }
        }
        return obj;
    },
    create: function (base) {
        return exports.InputValidation.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseInputValidation();
        message.required = (_a = object.required) !== null && _a !== void 0 ? _a : false;
        message.length = (object.length !== undefined && object.length !== null)
            ? exports.InputValidation_Length.fromPartial(object.length)
            : undefined;
        message.file_size = (_b = object.file_size) !== null && _b !== void 0 ? _b : 0;
        message.content_type = Object.entries((_c = object.content_type) !== null && _c !== void 0 ? _c : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Boolean(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseInputValidation_Length() {
    return { min: 0, max: 0 };
}
exports.InputValidation_Length = {
    fromJSON: function (object) {
        return {
            min: isSet(object.min) ? globalThis.Number(object.min) : 0,
            max: isSet(object.max) ? globalThis.Number(object.max) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.min !== 0) {
            obj.min = Math.round(message.min);
        }
        if (message.max !== 0) {
            obj.max = Math.round(message.max);
        }
        return obj;
    },
    create: function (base) {
        return exports.InputValidation_Length.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseInputValidation_Length();
        message.min = (_a = object.min) !== null && _a !== void 0 ? _a : 0;
        message.max = (_b = object.max) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseInputValidation_ContentTypeEntry() {
    return { key: "", value: false };
}
exports.InputValidation_ContentTypeEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== false) {
            obj.value = message.value;
        }
        return obj;
    },
    create: function (base) {
        return exports.InputValidation_ContentTypeEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseInputValidation_ContentTypeEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseInputValue() {
    return {
        name: exports.InputName.INPUT_NAME_UNSPECIFIED,
        number: undefined,
        str: undefined,
        boolean: undefined,
        files: undefined,
    };
}
exports.InputValue = {
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? inputNameFromJSON(object.name) : exports.InputName.INPUT_NAME_UNSPECIFIED,
            number: isSet(object.number) ? globalThis.Number(object.number) : undefined,
            str: isSet(object.str) ? globalThis.String(object.str) : undefined,
            boolean: isSet(object.boolean) ? globalThis.Boolean(object.boolean) : undefined,
            files: isSet(object.files) ? exports.InputFiles.fromJSON(object.files) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.name !== exports.InputName.INPUT_NAME_UNSPECIFIED) {
            obj.name = inputNameToJSON(message.name);
        }
        if (message.number !== undefined) {
            obj.number = Math.round(message.number);
        }
        if (message.str !== undefined) {
            obj.str = message.str;
        }
        if (message.boolean !== undefined) {
            obj.boolean = message.boolean;
        }
        if (message.files !== undefined) {
            obj.files = exports.InputFiles.toJSON(message.files);
        }
        return obj;
    },
    create: function (base) {
        return exports.InputValue.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseInputValue();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : exports.InputName.INPUT_NAME_UNSPECIFIED;
        message.number = (_b = object.number) !== null && _b !== void 0 ? _b : undefined;
        message.str = (_c = object.str) !== null && _c !== void 0 ? _c : undefined;
        message.boolean = (_d = object.boolean) !== null && _d !== void 0 ? _d : undefined;
        message.files = (object.files !== undefined && object.files !== null)
            ? exports.InputFiles.fromPartial(object.files)
            : undefined;
        return message;
    },
};
function createBaseInputFile() {
    return { attachment_id: "", file_name: "", url: undefined };
}
exports.InputFile = {
    fromJSON: function (object) {
        return {
            attachment_id: isSet(object.attachment_id) ? globalThis.String(object.attachment_id) : "",
            file_name: isSet(object.file_name) ? globalThis.String(object.file_name) : "",
            url: isSet(object.url) ? globalThis.String(object.url) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.attachment_id !== "") {
            obj.attachment_id = message.attachment_id;
        }
        if (message.file_name !== "") {
            obj.file_name = message.file_name;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        return obj;
    },
    create: function (base) {
        return exports.InputFile.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseInputFile();
        message.attachment_id = (_a = object.attachment_id) !== null && _a !== void 0 ? _a : "";
        message.file_name = (_b = object.file_name) !== null && _b !== void 0 ? _b : "";
        message.url = (_c = object.url) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
function createBaseInputFiles() {
    return { files: [] };
}
exports.InputFiles = {
    fromJSON: function (object) {
        return {
            files: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.files) ? object.files.map(function (e) { return exports.InputFile.fromJSON(e); }) : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.files) === null || _a === void 0 ? void 0 : _a.length) {
            obj.files = message.files.map(function (e) { return exports.InputFile.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.InputFiles.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseInputFiles();
        message.files = ((_a = object.files) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.InputFile.fromPartial(e); })) || [];
        return message;
    },
};
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=input.js.map